import styled from 'styled-components';

export const ProjectListItem = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 8px;
`;

export const ProjectBadge = styled.div<{$color: string}>`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 4px 8px;
	border-radius: 4px;
	background: ${({$color}) => $color};
	flex-shrink: 0;
	font-size: 12px;
	font-weight: 600;
	color: #232334;
	white-space: nowrap;
`;

export const RemoveButton = styled.button`
	all: unset;
	cursor: pointer;
	display: flex;
	align-items: center;
	margin-left: auto;
	flex-shrink: 0;
	opacity: 0.6;
	&:hover {
		opacity: 1;
	}
`;
